import { Bank } from "./bank";
import { BankService } from "./bankService";
import { BankRepositoryImpl } from "./bankRepositoryImpl";

/**
 * Controlador de bancos brasileiros via BrasilAPI.
 */
export abstract class BankController {
  private static readonly service = new BankService(new BankRepositoryImpl());

  /**
   * Retorna a lista de todos os bancos disponíveis.
   * @returns Lista de bancos com ISPB, código COMPE e nome
   * @example
   * ## Uso
   * ```javascript
   * const banks = await BankController.list()
   * for (const bank of banks) {
   *  console.log(bank.toString());
   * }
   * ```
   */
  static async list(): Promise<Bank[]> {
    return await BankController.service.list();
  }

  /**
   * Busca bancos cujo nome completo contenha o texto informado.
   * @param query Texto parcial do nome do banco (insensível a maiúsculas)
   * @returns Lista de bancos correspondentes
   */
  static async findByFullName(query: string): Promise<Bank[]> {
    return await BankController.service.findByFullName(query);
  }

  /**
   * Filtra bancos pelo código COMPE numérico ou por nome completo (texto parcial).
   * @param query Código numérico ou texto parcial do nome do banco
   * @returns Lista de bancos correspondentes
   */
  static async filterByCodeOrFullName(query: string): Promise<Bank[]> {
    return await BankController.service.filterByCodeOrFullName(query);
  }
}
